import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ['container', 'clickableZone'];

  connect() {
    this.isDragging = false;
    this.startX = 0;
    this.scrollLeft = 0;

    this.containerTarget.addEventListener('mousedown', this._handleMouseDown.bind(this));
    this.containerTarget.addEventListener('mousemove', this._handleMouseMove.bind(this));
    this.containerTarget.addEventListener('mouseup', this._handleMouseUp.bind(this));
  }

  disconnect() {
    this.containerTarget.removeEventListener('mousedown', this._handleMouseDown.bind(this));
    this.containerTarget.removeEventListener('mousemove', this._handleMouseMove.bind(this));
    this.containerTarget.removeEventListener('mouseup', this._handleMouseUp.bind(this));
  }

  _handleMouseDown(event) {
    if (event.target !== this.clickableZoneTarget) return;

    event.preventDefault();
    this.isDragging = true;
    this.startX = event.pageX - this.containerTarget.offsetLeft;
    this.scrollLeft = this.containerTarget.scrollLeft;
  }

  _handleMouseMove(event) {
    if (!this.isDragging) return;

    event.preventDefault();
    const x = event.pageX - this.containerTarget.offsetLeft;
    const scroll = (x - this.startX) * 2; // Increase scroll speed
    this.containerTarget.scrollLeft = this.scrollLeft - scroll;
  }

  _handleMouseUp() {
    this.isDragging = false;
  }
}
